import React, { useState } from "react";
import {
  Box,
  Flex,
  Text,
  Button,
  Icon,
  Spinner,
  Center,
} from "@chakra-ui/react";
import { TimeIcon } from "@chakra-ui/icons";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";
import { getChatRoutebythreadid } from "@root/utils";
import useChatHistory from "@root/hooks/useChatHistory";
import { Paginate } from "@root/components/pagination";
import { CHATBOT_TYPE, PAGINATION_DEFAULTS } from "@root/constants";
import { ListIcon } from "@root/assets/icons/view-report";
import { formatDate } from "@root/utils/date-helper";

interface ChatListProps {
  chats: any[];
  count: number;
  selectedToggle: any;
  onPageChange: (page: number) => void;
  page: number;
  showPagination?: boolean;
}

interface ChatbotPayload {
  type: CHATBOT_TYPE;
  limit: number;
  page: number;
  source?: string;
}

const ChatList: React.FC<ChatListProps> = ({
  chats,
  count,
  selectedToggle,
  onPageChange,
  page,
  showPagination = true,
}) => {
  const { t } = useTranslation("common");
  const { loading } = useChatHistory();
  const navigate = useNavigate();

  if (loading) {
    return (
      <Center p={4}>
        <Spinner size="lg" color="blue.500" />
      </Center>
    );
  }

  return (
    <>
      {chats?.map((chat, index: number) => (
        <Box
          key={index}
          padding="20px"
          mb={3}
          position="relative"
          _after={{
            content: '""',
            position: "absolute",
            bottom: 0,
            left: "30px",
            right: "30px",
            bg: "#E6E6E6",
            height: "0.5px",
          }}
        >
          <Flex justify="space-between" align="center">
            <Box>
              <Text fontWeight="600">{chat?.chat_title}</Text>
              <Flex align="center" gap={1} color="gray.500" fontSize="sm">
                <Icon as={TimeIcon} />
                <Text>
                  {chat?.createdAt
                    ? formatDate(chat.createdAt, "YYYY-MM-DD HH:mm:ss")
                    : "-"}
                </Text>
              </Flex>
            </Box>
            <Button
              color="black"
              variant="outline"
              bg="#EBEBEB"
              size="sm"
              onClick={() => navigate(getChatRoutebythreadid(chat))}
              gap={2}
            >
              {t("dashboard.viewChat")}
              <ListIcon />
            </Button>
          </Flex>
        </Box>
      ))}

      {/* Pagination goes outside of the map */}
      {showPagination && (
        <Flex width="100%" justifyContent={"center"}>
          <Paginate
            page={page}
            count={count}
            pageSize={PAGINATION_DEFAULTS.PAGESIZE}
            onPageChange={onPageChange}
          />
        </Flex>
      )}
    </>
  );
};

export default ChatList;
